import React from "react";
import { outlineFocus } from "utils";

function operationStatus(props) {
  return (
    <div className="en_advence">
      <div className="sub_title">
        Backup Notifications
        <label className="switch">
          <span className="switch_notify">Notify always</span>
          <input
            type="checkbox"
            checked={
              props.operationStatus.onSuccess && props.operationStatus.onFailure
            }
            onChange={e => {
              props.toggleNotificationOperationStatus("onSuccess");
              props.toggleNotificationOperationStatus("onFailure");
            }}
          />
          <span className="slider round"></span>
        </label>
      </div>
      <span class="en_advance_text">
        Receive notifications for all backup results at this email address
      </span>
    </div>
  );
}

export default operationStatus;
